import ReactGA from 'react-ga'

ReactGA.initialize('UA-96115966-1')



// WEBPACK FOOTER //
// ./src/startup/google-analytics.js